import { PublicPlan, PeriodUnit } from '@wix/ambassador-pricing-plans-v2-plan/types';

export const HIGHGLIGHTED_MOCK_PLAN_ID = 'some-id-2';

export const plansFixture: PublicPlan[] = [
  {
    id: 'some-id-1',
    createdDate: new Date(),
    updatedDate: new Date(),
    perks: {
      values: ['6 classes', '3 individual sessions', 'Online resources'],
    },
    description: 'Explore the basics with this introductory course',
    name: 'Beginner',
    buyerCanCancel: false,
    pricing: {
      freeTrialDays: 0,
      price: {
        value: '15',
        currency: 'USD',
      },
      singlePaymentForDuration: {
        count: 3,
        unit: PeriodUnit.MONTH,
      },
    },
  },
  {
    id: HIGHGLIGHTED_MOCK_PLAN_ID,
    createdDate: new Date(),
    updatedDate: new Date(),
    perks: {
      values: [
        '6 classes',
        '3 individual sessions',
        'Online resources',
        '1 guest pass',
        'Free WiFi',
        'Weekly newsletter',
      ],
    },
    description: 'Perfect for creatives, freelancers, and experienced',
    name: 'Pro',
    buyerCanCancel: false,
    pricing: {
      freeTrialDays: 0,
      price: {
        value: '10',
        currency: 'USD',
      },
      subscription: {
        cycleDuration: {
          count: 1,
          unit: PeriodUnit.MONTH,
        },
        cycleCount: 12,
      },
    },
  },
  {
    id: 'some-id-3',
    createdDate: new Date(),
    updatedDate: new Date(),
    perks: {
      values: [
        '6 classes',
        '3 individual sessions',
        'Online resources',
        '1 guest pass',
        'Free WiFi',
        'Weekly newsletter',
        'Priority support',
      ],
    },
    description: 'Unlimited access to professional content',
    name: 'VIP',
    buyerCanCancel: false,
    pricing: {
      freeTrialDays: 0,
      price: {
        value: '30',
        currency: 'USD',
      },
      subscription: {
        cycleDuration: {
          count: 1,
          unit: PeriodUnit.MONTH,
        },
        cycleCount: 0,
      },
    },
  },
];
